import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from '../../../../services/AxiosInstance';
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

const RateList = (props) =>{
    //console.log(props);
    const { id,name,bid,bidh,ask,askl,symbol,state_id } = props.obj;
    let history = useHistory();
    //const userdetails = JSON.parse(localStorage.getItem('userDetails'));
    const deleteDepartment = () => {
      //axios.defaults.headers.common['Authorization'] = `Bearer ${userdetails.idToken}`;
      //axios.defaults.headers.post['Content-Type'] = 'application/json';
      axios
         .delete(
         "/api/auth/delete-rate/" + id)
            .then((res) => {
               if (res.status === 200) {
               alert("Record successfully deleted");
               //window.location.reload();
               history.push("/dashboard");
               } else Promise.reject();
            })
            .catch((err) => alert("Something went wrong"));
      };
      const drop = (
        <Dropdown>
           <Dropdown.Toggle variant="" className="btn btn-primary tp-btn-light sharp i-false">
              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                 <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                    <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                    <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                 </g>
              </svg>
           </Dropdown.Toggle>
           <Dropdown.Menu>
              <Dropdown.Item>
                 <Link 
                     className="edit-link disabled-link" 
                     //to={"/edit-department/" + id}
                     >
                     Edit
                  </Link>
               </Dropdown.Item>
              <Dropdown.Item  onClick={deleteDepartment}  className="text-danger">
                  Delete
              </Dropdown.Item>
           </Dropdown.Menu>
        </Dropdown>
     );
     let state_name = "";
      if(state_id == 24){
         state_name = "Gujarat";
      }else if(state_id == 37){
         state_name = "Andhra Pradesh";
      }else if(state_id == 7){
         state_name = "Delhi";
      }else if(state_id == 13){
         state_name = "Karala";
      }else if(state_id == 29){
         state_name = "Karnataka";
      }else if(state_id == 23){
         state_name = "Madhya Pradesh";
      }else if(state_id == 8){
         state_name = "Rajasthan";
      }else if(state_id == 33){
         state_name = "Tamil Nadu";
      }else if(state_id == 36){
         state_name = "Telangana";
      }
    return (
        <tr className="btn-reveal-trigger">
          <td className="py-3">{name}</td>
          <td className="py-3">{bid}</td>
          <td className="py-3">{bidh}</td>
          <td className="py-3">{ask}</td>
          <td className="py-3">{askl}</td>
          <td className="py-3">{state_name}</td>
          <td className="py-2 text-right">{drop}</td>
        </tr>
    );
}
export default RateList;